import React from "react";
import styles from "./UnavailableProductSkeleton.scss";

export default function UnavailableProductSkeleton() {
  return (
    <div className={styles.recommendations}>
      <div className={styles.recommendationsTitle}></div>
      <div className={styles.recommendationsGrid}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
